import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "logs-view"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-2 pt-4 col-12",
  style: {"text-align":"center"}
}, "Нет данных", -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tirscript3_loading = _resolveComponent("tirscript3-loading")!
  const _component_tirscript3_table_header_item = _resolveComponent("tirscript3-table-header-item")!
  const _component_tirscript3_table_body_item = _resolveComponent("tirscript3-table-body-item")!
  const _component_tirscript3_table = _resolveComponent("tirscript3-table")!

  return (_ctx.filter)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_tirscript3_loading, { loading: _ctx.isLoading }, null, 8, ["loading"]),
        _createVNode(_component_tirscript3_table, {
          items: _ctx.items,
          "template-columns": "auto 250px auto",
          style: {"overflow-x":"auto"}
        }, {
          header: _withCtx(() => [
            _createVNode(_component_tirscript3_table_header_item, null, {
              default: _withCtx(() => [
                _createTextVNode("Тип")
              ]),
              _: 1
            }),
            _createVNode(_component_tirscript3_table_header_item, null, {
              default: _withCtx(() => [
                _createTextVNode("Дата мониторинга")
              ]),
              _: 1
            }),
            _createVNode(_component_tirscript3_table_header_item, null, {
              default: _withCtx(() => [
                _createTextVNode(" Данные")
              ]),
              _: 1
            })
          ]),
          body: _withCtx((data) => [
            _createVNode(_component_tirscript3_table_body_item, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getHardwareLogType(data.item.Type)), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_tirscript3_table_body_item, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.m(data.item.DateMonitoring)), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_tirscript3_table_body_item, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(data.item.Value), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_tirscript3_table_body_item, null, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "detale",
                  onClick: ($event: any) => (_ctx.onReadMore(data.item.RequestId))
                }, " детали... ", 8, _hoisted_2)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["items"]),
        (!_ctx.noPagination && _ctx.items && _ctx.items.length == 0 && _ctx.isLoading == false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}